<template>
  <div class="card-header text-center">
    <h1 class="m-0 p-0 text-dark font-16">{{ $t('views.retailer.users.register.welcome') }},</h1>
    <h1 class="m-0 p-0 text-dark font-16 mt-1" v-if="$country.isNot('ro')">
      {{ $t('views.retailer.users.register.fill_the_form_below') }}
    </h1>
  </div>
</template>
<script>
export default {
  name: 'WelcomeCard',
  props: {},
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.card-header {
  border-bottom: 0;
}
</style>
